import React, {useContext} from 'react';
import '../styles/partials/components/_toolbar.scss';
import FolderOutline from '../images/folder-outline.svg';
import {GlobalContext} from "../context/GlobalState";

const Toolbar = () => {
  const {openCreateFolderModal} = useContext(GlobalContext);

  return (
    <div className="toolbar">
      <div className="new-folder" onClick={openCreateFolderModal}>
        <img src={FolderOutline} alt="New folder" />
        <p>New folder</p>
      </div>
    </div>
  );
};

export default Toolbar;
